export default {
    signin: {
        title: 'Sign in',

        intro: 'Log in',

        username: {
            label: 'Email',
            placeholder: 'Email',
        },
        password: {
            label: 'Password',
            placeholder: 'Password',
        },
        signinBtn: 'Sign in',
        forceLoginBtn: 'Force sign in',
    },

    signout: {
        title: 'Log out',
    },
}
